import { guardedFetch, authenticatedFetch } from "./utils";
import type { ApiResponse } from "../../types/api";
import API_CONSTANTS from "../constants/api";

// We enforce the key to exist, because it's required for the user settings save operation
export type UploadFields = { key: string } & Record<string, string>;
export type UploadUrlResponse = ApiResponse & {
  url: string,
  fields: UploadFields
};

// https://docs.aws.amazon.com/AmazonS3/latest/API/sigv4-post-example.html
// We just push all fields to the formData
const buildUploadFormData = (fields: UploadFields) => {
  return Object.entries(fields).reduce((formData, [key, value]) => {
    formData.append(key, value);
    return formData;
  }, new FormData());
};

export async function uploadFile(file: File, fields: UploadFields, uploadUrl: string): Promise<void> {
  const formData = buildUploadFormData(fields);
  formData.append("file", file);

  await guardedFetch(uploadUrl, {
    method: "POST",
    body: formData
  });
}

export async function getUploadUrl(mimeType: string): Promise<UploadUrlResponse> {
  const url = `${API_CONSTANTS.serverlessFunctionsBaseUrl}/get-upload-url`;

  const result = await authenticatedFetch(url, {
    method: "POST",
    body: JSON.stringify({ mimeType })
  }, undefined, {});

  return (await result.json()) as UploadUrlResponse;
}
